import React from 'react';
import CrudPage from '@modules/cruds/CrudPage';
import ChannelForm from './ChannelForm';
import withRouter from '@utils/wrappers/WithRouter';
import * as yup from 'yup'; // for everything
import { CChannel } from '@ts/ui-models';
import { defaultConfigComponent } from './Channels';

const ChannelSchema = yup.object().shape({
  name: yup.string().required().label('Channel name'),
  channelTypeId: yup.string().required().label('Channel type'),
  bound: yup.string().required().label('Purpose'),
  host: yup.string().label('Host').when('channelTypeId', {
    is: 'email',
    then: yup.string().required(),
  }),
  port: yup.number().label('Port').when('channelTypeId', {
    is: 'email',
    then: yup.number().required(),
  }),
  sender: yup.string().label('Sender').when('channelTypeId', {
    is: 'email',
    then: yup.string().required(),
  }),
  user: yup.string().label('User').when('channelTypeId', {
    is: 'email',
    then: yup.string().required(),
  }),
  pass: yup.string().label('Password').when('channelTypeId', {
    is: 'email',
    then: yup.string().required(),
  }),
  dbName: yup.string().label('Database name').when('channelTypeId', {
    is: 'database',
    then: yup.string().required(),
  }),
  tableName: yup.string().label('Table name').when('channelTypeId', {
    is: 'database',
    then: yup.string().required(),
  }),
  targetSystem: yup.string().label('Target system').when('channelTypeId', {
    is: 'database',
    then: yup.string().required(),
  }),
  endpoint: yup
    .string()
    .label('Endpoint')
    .when(['channelTypeId', 'bound'], {
      is: (channelTypeId, bound) =>
        bound === 'inbound' && (channelTypeId === 'http' || channelTypeId === 'mqtt' || channelTypeId === 'amqp091'),
      then: yup.string().required(),
    }),
  topic: yup
    .string()
    .label('Topic')
    .when(['channelTypeId', 'bound'], {
      is: (channelTypeId, bound) => bound === 'outbound' && channelTypeId === 'mqtt',
      then: yup.string().required(),
    }),
});

const ChannelPage = props => {
  return (
    <CrudPage
      key={'channelPage'}
      configComponent={defaultConfigComponent}
      form={ChannelForm}
      validationSchema={ChannelSchema}
      defaultValues={{
        bound: 'inbound',
      }}
    />
  );
};

export default withRouter(ChannelPage);
